<template>

<app-view-sheet-field :is-sticky="isSticky" class="comment" :field="field" :filter="filter">

    <template v-if="item.play.comment">{{ item.play.comment }}</template>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed']

}

</script>

<style scoped>

.comment {
    line-height: 18px;
}

</style>